import { render, staticRenderFns } from "./hireTable.vue?vue&type=template&id=b45ae4f4"
import script from "./hireTable.vue?vue&type=script&lang=js"
export * from "./hireTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports